export type DialerWidgetMode = 'two_columns' | 'three_columns';

export const DIALER_WIDGET_MODE_EVENT = 'callhub:dialer-widget-mode-change';
export const DIALER_WIDGET_DRAG_LOCK_EVENT = 'callhub:dialer-widget-drag-lock-change';
export const DIALER_UI_STORAGE_KEY = 'callhub:dialer-ui:v1';

export const DIALER_WIDGET_MODE_OPTIONS: Array<{
  value: DialerWidgetMode;
  label: string;
}> = [
  { value: 'two_columns', label: '2 Col' },
  { value: 'three_columns', label: '3 Col' },
];

export function normalizeDialerWidgetMode(raw: unknown): DialerWidgetMode {
  if (raw === 'two_columns' || raw === 'three_columns') return raw;
  return 'two_columns';
}

export function readDialerWidgetModeFromStorage(): DialerWidgetMode {
  if (typeof window === 'undefined') return 'two_columns';

  const raw = window.localStorage.getItem(DIALER_UI_STORAGE_KEY);
  if (!raw) return 'two_columns';

  try {
    const parsed = JSON.parse(raw) as { messagesWidgetMode?: unknown };
    return normalizeDialerWidgetMode(parsed.messagesWidgetMode);
  } catch {
    return 'two_columns';
  }
}

export function readDialerWidgetDragLockFromStorage(): boolean {
  if (typeof window === 'undefined') return false;

  const raw = window.localStorage.getItem(DIALER_UI_STORAGE_KEY);
  if (!raw) return false;

  try {
    const parsed = JSON.parse(raw) as { widgetDragLocked?: unknown };
    return parsed.widgetDragLocked === true;
  } catch {
    return false;
  }
}

export function persistDialerWidgetModeToStorage(mode: DialerWidgetMode) {
  if (typeof window === 'undefined') return;

  let parsed: Record<string, unknown> = {};
  const raw = window.localStorage.getItem(DIALER_UI_STORAGE_KEY);
  if (raw) {
    try {
      parsed = JSON.parse(raw) as Record<string, unknown>;
    } catch {
      parsed = {};
    }
  }

  window.localStorage.setItem(
    DIALER_UI_STORAGE_KEY,
    JSON.stringify({
      ...parsed,
      messagesWidgetMode: mode,
    }),
  );
}

export function persistDialerWidgetDragLockToStorage(locked: boolean) {
  if (typeof window === 'undefined') return;

  let parsed: Record<string, unknown> = {};
  const raw = window.localStorage.getItem(DIALER_UI_STORAGE_KEY);
  if (raw) {
    try {
      parsed = JSON.parse(raw) as Record<string, unknown>;
    } catch {
      parsed = {};
    }
  }

  window.localStorage.setItem(
    DIALER_UI_STORAGE_KEY,
    JSON.stringify({
      ...parsed,
      widgetDragLocked: locked,
    }),
  );
}

export function emitDialerWidgetModeChange(mode: DialerWidgetMode) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(DIALER_WIDGET_MODE_EVENT, {
      detail: { mode },
    }),
  );
}

export function emitDialerWidgetDragLockChange(locked: boolean) {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(DIALER_WIDGET_DRAG_LOCK_EVENT, {
      detail: { locked },
    }),
  );
}
